import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router, NavigationStart } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private spinner = inject(NgxSpinnerService);
  private router = inject(Router, { optional: true });
  private pendingRequests = 0;
  private generation = 0;
  private loading$ = new BehaviorSubject<boolean>(false);

  constructor() {
    if (this.router) {
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          // Reset spinner on page navigation to prevent orphaned spinners
          this.forceHide();
        }
      });
    }
  }

  get isLoading$(): Observable<boolean> {
    return this.loading$.asObservable();
  }

  /** Returns the generation the caller's request belongs to; pass it back to hide(). */
  show(): number {
    this.pendingRequests++;
    if (this.pendingRequests === 1) {
      this.loading$.next(true);
      this.spinner.show();
    }
    return this.generation;
  }

  /**
   * generation ties this hide() back to the show() that started it. A request already
   * in flight when forceHide() ran belongs to an abandoned generation — its hide() is
   * ignored instead of decrementing the counter a newer page has since started.
   */
  hide(generation?: number): void {
    if (generation !== undefined && generation !== this.generation) {
      return;
    }
    this.pendingRequests--;
    if (this.pendingRequests <= 0) {
      this.pendingRequests = 0;
      this.loading$.next(false);
      this.spinner.hide();
    }
  }

  forceHide(): void {
    this.generation++;
    this.pendingRequests = 0;
    this.loading$.next(false);
    this.spinner.hide();
  }
}
